// GA/GTM 관련 ID·스토리지 키·이벤트 이름의 단일 선언 지점.
//
// GA4 측정 ID(G-...)는 여기에 없다. 그 값은 GTM 컨테이너 안에서만 쓰이는 정보이고,
// 앱은 어느 GA 속성으로 데이터가 가는지 알 필요가 없다. (예전에는 window["ga-disable-G-..."]
// 플래그를 만들기 위해 코드에 박혀 있었는데, 그 차단 방식 자체를 GA4 데이터 필터로 옮겼다.)

/**
 * GTM 컨테이너 ID. 값이 비면 _document 가 부트스트랩 스크립트를 렌더하지 않으므로
 * 환경변수를 빈 문자열로 두는 것이 킬 스위치가 된다.
 * 리터럴 폴백을 남기는 이유는 .env 갱신이 누락돼도 빌드가 올바르게 동작하게 하려는 것.
 */
export const GTM_CONTAINER_ID =
  process.env.NEXT_PUBLIC_GTM_ID ?? "GTM-W65BT33P";

/**
 * 마지막으로 확인된 traffic_type 을 담아두는 localStorage 키.
 * _document 부트스트랩이 gtm.js 보다 먼저 이 값을 읽어, 로그인 전 첫 이벤트에도
 * 내부 트래픽 라벨이 붙게 한다. 스니펫이 문자열 === 로 직접 비교하므로 JSON 이 아니다.
 */
export const TRAFFIC_TYPE_STORAGE_KEY = "pathrade.analytics.trafficType";

/**
 * 로컬에서 GTM 을 강제로 띄우는 이스케이프 해치.
 * localStorage.setItem("pathrade.analytics.force", "1") 후 리로드하면 컨테이너가 로드된다.
 * 코드를 고치지 않고 태그를 검증할 수 있게 하기 위한 것.
 */
export const ANALYTICS_FORCE_KEY = "pathrade.analytics.force";

// dataLayer 이벤트 이름.
//
// GA4 가 받는 이벤트 이름은 GTM 태그에서 정하므로, 여기 이름은 GTM 트리거 이름일 뿐이다.
// pathrade_ 접두사를 붙여 gtag/GA4 가 같은 dataLayer 에 넣는 내부 이벤트와 섞이지 않게 한다.
export const EVENT_IDENTITY = "pathrade_identity";
export const EVENT_PAGE_VIEW = "pathrade_page_view";
export const EVENT_ORDER_BUTTON_CLICK = "order_button_click";
